// extracted by mini-css-extract-plugin
export default {"section":"WrapperFiltroSection_section__Axrja","title":"WrapperFiltroSection_title__xJz9P"};